import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {appContext} from '../../../../app.context';
import {ArchiSmallERRORS} from '../../../../commons/errors';

class ConservazioneCaricaDocumentoNomineDelegheConservazioneStep2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.years = [];
    const curr_year = new Date().getFullYear();
    for (let i = curr_year - 1; i <= curr_year; i++) {
      $scope.years.push(i);
    }
    const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {
      anno: number,
      scadenza: string
    }[];
    if (years) {
      for (let year of years) {
        if (new Date(year.scadenza) > new Date()) {
          $scope.years.push(year.anno);
        }
      }
    }

    $scope.cliente = {};
    $scope.anagraficaIsNew = true;
    $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    let isNomeClienteDisabled;
    let isCognomeClienteDisabled;
    let isRagioneSocialeClienteDisabled;
    let isClienteCFDisabled;
    let isClientePIVADisabled;

    $scope.documentTypes = ['Atto di Nomina Responsabile della Conservazione', 'Piano deleghe altre figure di riferimento'];

    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', {'classeDocumentale': $scope.classeDocumentale});
    };

    // <editor-fold desc='openWorkerModal'>

    $scope.openWorkerModal = (size) => {
      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');

      if ($scope.anagraficaIsNew) {
        $scope.saveAnagrafica();
      }

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerNomineDelegheConservazioneModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          }
        }
      });
    };

    // </editor-fold>

    $scope.saveAnagrafica = () => {
      let anagrafica = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.clienteNome,
        cognome: $scope.settings.clienteCognome,
        company_name: $scope.settings.clienteDenominazione,
        fiscal_code: $scope.settings.clienteCodiceFiscale,
        piva: $scope.settings.clientePIVA,
        type: $scope.settings.clienteDenominazione !== '' ? 2 : `${$scope.settings.clienteNome} ${$scope.settings.clienteCognome}`.trim() !== '' ? 1 : 2
      };

      ArchiSmallServices.insertAnagrafica(anagrafica)
        .then((response: any) => {
          // ??
        }, (error) => {
          if (error.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
            $rootScope.alert('error', 'Anagrafica già esistente');
          }
        });
    };

    $rootScope.formsubmitted = false;

    // <editor-fold desc='setConservazioneSettings'>
    $scope.setConservazioneSettings = () => {
      $scope.settings.clienteDenominazione = $scope.cliente.anagrafica;
      let classeDocumentale = $scope.settings.classeDocumentale.key;
      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ??
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.cliente.anagrafica = $scope.settings.clienteDenominazione;
            isNomeClienteDisabled = $scope.settings.clienteNome !== '' && $scope.settings.clienteNome !== undefined;
            isCognomeClienteDisabled = $scope.settings.clienteCognome !== '' && $scope.settings.clienteCognome !== undefined;
            isRagioneSocialeClienteDisabled = $scope.settings.clienteDenominazione !== '' && $scope.settings.clienteDenominazione !== undefined;
            isClienteCFDisabled = $scope.settings.clienteCodiceFiscale !== '' && $scope.settings.clienteCodiceFiscale !== undefined;
            isClientePIVADisabled = $scope.settings.clientePIVA !== '' && $scope.settings.clientePIVA !== undefined;

          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
    }

    $scope.dpOpened = {
      dataDocumento: false,
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };

    /* tslint:disable:no-string-literal */
    $scope.autoOpen = ($event, opened) => {
      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    /* tslint:enable:no-string-literal */
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.getAnagraficaTypeaheadValues = () => {
      ArchiSmallServices.getAnagraficaTypeaheadValues()
        .then((response: any) => {
          $scope.anagrafica = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getAnagraficaTypeaheadValues();

    $scope.autocompleteFields = (item) => {
      if (item !== undefined && typeof item === 'object') {

        if (item._id === -1) {
          $scope.settings.clienteNome = '';
          $scope.settings.clienteCognome = '';
          $scope.settings.clienteDenominazione = '';
          $scope.settings.clientePIVA = '';
          $scope.settings.clienteCodiceFiscale = '';
          isNomeClienteDisabled = false;
          isCognomeClienteDisabled = false;
          isRagioneSocialeClienteDisabled = false;
          isClienteCFDisabled = false;
          isClientePIVADisabled = false;
          $scope.anagraficaIsNew = true;
        } else {
          $scope.settings.clienteNome = item.nome;
          $scope.settings.clienteCognome = item.cognome;
          $scope.settings.clienteDenominazione = item.company_name;
          $scope.settings.clientePIVA = item.piva;
          $scope.settings.clienteeCodiceFiscale = item.fiscal_code;
          isNomeClienteDisabled = item.nome !== '' && item.nome !== undefined;
          isCognomeClienteDisabled = item.cognome !== '' && item.cognome !== undefined;
          isRagioneSocialeClienteDisabled = item.company_name !== '' && item.company_name !== undefined;
          isClienteCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
          isClientePIVADisabled = item.piva !== '' && item.piva !== undefined;
          $scope.anagraficaIsNew = false;
        }
      }
    };

    $scope.clear = ($event, $select) => {
      UISelectService.clear($event, $select);

      $scope.cliente.anagrafica = '';
      $scope.settings.clienteNome = '';
      $scope.settings.clienteCognome = '';
      $scope.settings.clienteDenominazione = '';
      $scope.settings.clientePIVA = '';
      $scope.settings.clienteCodiceFiscale = '';
      isNomeClienteDisabled = false;
      isCognomeClienteDisabled = false;
      isRagioneSocialeClienteDisabled = false;
      isClienteCFDisabled = false;
      isClientePIVADisabled = false;
      $scope.anagraficaIsNew = false;
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.isNomeClienteDisabled = () => {
      return isNomeClienteDisabled;
    };
    $scope.isCognomeClienteDisabled = () => {
      return isCognomeClienteDisabled;
    };
    $scope.isRagioneSocialeClienteDisabled = () => {
      return isRagioneSocialeClienteDisabled;
    };
    $scope.isClienteCFDisabled = () => {
      return isClienteCFDisabled;
    };
    $scope.isClientePIVADisabled = () => {
      return isClientePIVADisabled;
    };
  }
}

export const ConservazioneCaricaDocumentoNomineDelegheConservazioneStep2Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-nomine-deleghe-conservazione-step2.html'),
  controller: ConservazioneCaricaDocumentoNomineDelegheConservazioneStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-nomine-deleghe-conservazione-step2/conservazione-carica-documento-nomine-deleghe-conservazione-step2.ts